import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { finalize, Subject, takeUntil } from 'rxjs';
import { AutomationService } from '../../../../../services/automation.service';
import type {
  AutomationLogDetails,
  AutomationLogDetailsPayload,
  AutomationLogItem,
} from '../../../../../modules/crm/automation-v2/components-v2/automation-logs/automation-logs.interface';
import { StackedSidebarService } from '../../../../../services/stacked-sidebar.service';

@Component({
  selector: 'app-automation-log-details',
  templateUrl: './automation-log-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AutomationLogDetailsComponent implements OnInit, OnDestroy {
  @Input({ required: true }) payload!: AutomationLogDetailsPayload;
  @Output() close = new EventEmitter<void>();

  private readonly destroy$ = new Subject<void>();
  protected details?: AutomationLogDetails;
  protected loading = false;

  constructor(
    private readonly automationService: AutomationService,
    private readonly stackedSidebarService: StackedSidebarService,
  ) {}

  ngOnInit(): void {
    this.loadDetails();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected openChat(chatId?: string): void {
    if (!chatId) return;

    this.stackedSidebarService.openChats(chatId).subscribe();
  }

  protected formatEvent(event?: string): string {
    return event ? `automation_logs.events.${event}` : '';
  }

  protected formatReason(reason?: string): string {
    return reason ? `automation_logs.reasons.${reason}` : '';
  }

  protected formatTrigger(trigger?: string): string {
    return trigger ? `automation_action.${trigger.toLowerCase()}` : '';
  }

  protected formatAction(action?: string): string {
    return action ? `automation_action.${action.toLowerCase()}` : '';
  }

  protected hasDetails(step: AutomationLogItem): boolean {
    return !!step.error || !!step.error_code || !!step.payload;
  }

  private loadDetails(): void {
    this.loading = true;
    this.automationService
      .getAutomationLogDetails(this.payload.automationId, this.payload.taskId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.loading = false)),
      )
      .subscribe((details) => {
        this.details = details;
      });
  }
}
